module.exports = __webpack_public_path__ + "img/eswatini.e37c867a.svg";